import { render } from "./RecallPatientButton.vue?vue&type=template&id=5ff7170c"
import script from "./RecallPatientButton.vue?vue&type=script&lang=js"
export * from "./RecallPatientButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__